export default __webpack_public_path__ + "static/media/extingaImg_2.a7c6d631.webp";